<template>
    <div>
        <base-header :type="gradientType" class="pb-6 pb-8 pt-5 pt-md-8">
            <br><br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Wavelets - {{ _.startCase(selectedProfile)}}
                </base-button>
                <template v-if='isAccountOwner==false'>
                    <a @click.prevent="setCurrentProfile('wavelet_manager')" class="dropdown-item" href="#">Wavelet Manager</a>
                </template>
                <template v-else>
                    <a @click.prevent="setCurrentProfile('wavelet_settings')" class="dropdown-item" href="#">My Wavelets</a>
                    <a @click.prevent="setCurrentProfile('wavelet_marketplace')" class="dropdown-item" href="#">Wavelet Marketplace</a>
                </template>


            </base-dropdown>
        </base-header>
        <div v-if="selectedProfile == 'wavelet_manager' && developerMode == true" class="container-fluid mt--7">
            <wavelet-manager />
        </div>
        <div v-else class="container-fluid mt--7">
            <div class="row mt-7">
                <a-empty class='mt-5' :image-style="{height: '50px'}">
                    <span slot="description"> No Access </span>
                </a-empty>
            </div>
        </div>
        <div v-if="selectedProfile == 'wavelet_settings'" class="container-fluid mt--7">
            <wavelet-settings />
        </div>
        <div v-if="selectedProfile == 'wavelet_marketplace'" class="container-fluid mt--7">
            <wavelet-marketplace />
        </div>
    </div>
</template>


<script>
    import WaveletManager from '../Wavelet/WaveletManager.vue'
    import WaveletSettings from '../Wavelet/WaveletSettings.vue'
    import WaveletMarketplace from '../Wavelet/WaveletMarketplace.vue'
    import secureStorage from '../../controllers/secureStorage';

    export default {
        components:{
            WaveletManager, WaveletSettings, WaveletMarketplace
        },
        mounted: async function(){  
            if (this.isAccountOwner==true) {
                this.selectedProfile = "wavelet_settings"
            }
            await this.setBaseHeader();
        },
        computed: {
  
        },
        data() {
          return {
            isAccountOwner: secureStorage.getItem("isAccountOwner"),
            developerMode: secureStorage.getItem("developerMode"),
            selectedProfile: "wavelet_manager",
            gradientType: 'instore'
          }
        },
        methods: {
            setCurrentProfile(profile){
                this.selectedProfile = profile
            },
            async setBaseHeader(){
                if (this.developerMode == true){
                    this.gradientType = 'gradient-primary'
                } else {
                    this.gradientType = 'instore'
                }
            }
        }
    }
</script>

<style>
.ant-steps-item-process .ant-steps-item-icon {
    background: #65CB8F;
    border: #65CB8F;
}
.fix-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
}
</style>


